import React, {useEffect, useState} from 'react';

import {clearProducts, fetchProducts, PRODUCTS_PAGE_COUNT} from '../Products/actions';

import "./style.css"
import {useSelector} from "react-redux";
import {getProducts, getProductsFetching, getProductsHasMore} from "../Products/reducer";
import {setWindowScrollPosition} from "../../components/WindowDimensions";
import GlobalIcon from "../../icons/global-icon.png";
import PartnerOffers from "../../icons/partner-offers.png";
import MarketEntry from "../../icons/market-entry.png";
import { ReactComponent as ArrowIcon } from "../../icons/arrow-icon.svg";

import InfiniteView from "../../components/InfiniteView";
import GradientBox from "../../components/GradientBox/gradientBox";
import {getCompanies, getCompaniesFetching} from "../CongressOnline/reducer";
import {BrowserView, MobileView} from "react-device-detect";
import CompanyCard from "../CongressOnline";
import {COMPANIES_PAGE_COUNT, fetchCompanies} from "../CongressOnline/actions";
import config from "../../config/config";
import translations from "../../components/LanguageModal/translations";
import {getLanguage} from "../../components/LanguageModal/reducer";
import Products from "../Products";
import {Link} from "react-router-dom";
import ProductsContainer from "../../components/ProductsContainer";
import CatalogFilterSection from "../Catalog/catalogFilterSection";
import {fetchCatalogue} from "../Categories/actions";
import {getCategories} from "../Categories/reducer";
import {Image} from "semantic-ui-react";

export default function Home (props) {
    const {dispatch,
        userData,
        userLocation,
        mixpanel,
        routeAction,
        isPageReloaded,
        navigate,
    } = props;

    const loadMore = () => readCompanies(Math.round(companies.length / COMPANIES_PAGE_COUNT) + 1);
    const loading = useSelector((state) => getProductsFetching(state.products));
    const products = useSelector((state) => getProducts(state.products));
    const hasMore = useSelector((state) => getProductsHasMore(state.products));
    const companies = useSelector((state) => getCompanies(state.companies));
    const isFetching = useSelector((state) => getCompaniesFetching(state.companies));
    const categories = useSelector(state => getCategories(state.categories));



    const MAX_PRODUCTS_TO_DISPLAY = 4;
    const animalHusbandryCategoryId = 193;
    const cropProductionCategoryId = 197;
    const techniqueProductsId = 198;
    const manufacturingProductsId = 199;
    const anotherProductsId = 223;

    const animalHusbandryProducts = categories.find(cat => cat.cat_ID === 193)?.category_count || 0;
    const cropProductionProducts = categories.find(cat => cat.cat_ID === 197)?.category_count || 0;
    const techniqueProducts = categories.find(cat => cat.cat_ID === 198)?.category_count || 0;
    const manufacturingProducts = categories.find(cat => cat.cat_ID === 199)?.category_count || 0;
    const anotherProducts = categories.find(cat => cat.cat_ID === 223)?.category_count || 0;
    const aquacultureProducts = categories.find(cat => cat.cat_ID === 371)?.category_count || 0;

    const language = useSelector(getLanguage);
    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    const allWordsArray = {
        ru: ["товар", "товара", "товаров"],
        en: ["product","products","products"]
    };

    function getWordsArray(language) {
        const languageString = language[0] + language[1];
        return allWordsArray[languageString] ;
    }

    function NormalizeCountForm(number, words_arr) {
        number = Math.abs(number);
        if (Number.isInteger(number)) {
            let options = [2, 0, 1, 1, 1, 2];
            return words_arr[(number % 100 > 4 && number % 100 < 20) ? 2 : options[(number % 10 < 5) ? number % 10 : 5]];
        }
        return words_arr[1];
    }

    const wordsArray = getWordsArray(language);

    useEffect(() => {
        dispatch(fetchCatalogue(null))
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if ( routeAction === 'PUSH' || isPageReloaded ) {

            setWindowScrollPosition();
        }
        if (mixpanel)
            mixpanel.track('Products List View', { ...userLocation, ...userData });
    }, []);



    useEffect(() => {
        if (isPageReloaded) {
            setWindowScrollPosition();
        }
    }, [props]);

    useEffect(() => {
        clearProducts()
        readCompanies(1);
    }, []);

    const readCompanies = (page) => {
        dispatch(fetchCompanies(
            {
                page,
                per_page: COMPANIES_PAGE_COUNT,
                order: 'asc',
                orderby: 'id',
            }
        ));
    }

     function  loadProducts() {
       const nextPage = Math.round(products.length / PRODUCTS_PAGE_COUNT) + 1;
       readProducts(nextPage);
      }

      function readProducts(page) {
        dispatch(fetchProducts({
          page,
          order: 'asc',
          orderby: 'title',
            home_category: config.CATALOG_CATEGORIES_ID,
        }));
      }



    const [animalHusbandryFilter, setAnimalHusbandryFilter] = useState(null);
    const [cropProductionFilter, setCropProductionFilter] = useState(null);


    const handleAnimalHusbandryFilterChange = (filterId) => {
        setAnimalHusbandryFilter(filterId);
    };

    const handleCropProductionFilterChange = (filterId) => {
        setCropProductionFilter(filterId);
    };

    const animalHusbandryFilters = [
        { id: 195, label: "Корм для МРС" },
        { id: 194, label: "Корм для КРС" },
        { id: 207, label: t('pigFood') },
        { id: 206, label: t('birdFood') },
        { id: 208, label: 'Корм для коней' },
    ];

    const cropProductionFilters = [
        { id: 200, label: t('fertilizers') },
        { id: 201, label: t('additives')  },
        { id: 205, label: 'Оборудование для переработки зерна'  },
        { id: 203, label: 'Семена'  },
    ];


    const SupplierCard = () => {
        return (
            <>

                <BrowserView>
                    <div className="suppliers-container">
                        {companies ? companies.slice(0, 6).map((company) => (
                        <div className="supplier-card" onClick={() => navigate(`congress-online/company/${company.id}`)}>
                            <img src={company.logo} className='supplier-logo' />
                        </div>
                        )) : ""}
                    </div>
                </BrowserView>
                <MobileView>
                    <div className="suppliers-container mobile">
                        {companies ? companies.slice(0, 4).map((company) => (
                            <div className="supplier-card mobile" onClick={() => navigate(`congress-online/company/${company.id}`)}>
                                <img src={company.logo} className='supplier-logo mobile'/>
                            </div>
                        )) : ""}
                    </div>
                </MobileView>
            </>
        )

    }



    const BestOffers = () => {

        const prdcts = products ? products.sort((a, b) => b.average_rating - a.average_rating) : null

        return (
            <>
                <BrowserView>
                    <div className='best-offers'>
                        {prdcts.slice(0, 3).map(offer =>
                            <div className='best-offer-card' onClick={() => navigate(`products/product-card/${offer.id}`)}>
                                <span className='offer-title'>{offer.name}</span>
                                <Image
                                    className="offer-img"
                                    src={offer.images.map(a => a.src).slice(0,1)}
                                    wrapped
                                    size="small"
                                    // style={{ marginLeft: '55px', marginBottom: '7px', marginTop: '8px' }}
                                />
                            </div>
                        )}
                    </div>


                </BrowserView>

                <MobileView>
                    <div className='best-offers mobile'>
                        {prdcts.slice(0, 2).map(offer =>
                            <div className='best-offer-card mobile'
                                 onClick={() => navigate(`products/product-card/${offer.id}`)}>
                                <span className='offer-title mobile'>{offer.name}</span>
                                <Image
                                    className="offer-img mobile"
                                    src={offer.images.map(a => a.src).slice(0, 1)}
                                    wrapped
                                    size="tiny"
                                    // style={{ marginLeft: '55px', marginBottom: '7px', marginTop: '8px' }}
                                />
                            </div>
                        )}
                    </div>
                </MobileView>
            </>
        )
    }


    return (
        <>
            <BrowserView>
                {/*<div className='venue-gradient-box'>*/}
                {/*    <GradientBox/>*/}
                {/*</div>*/}

                <div className='venue-home-title'>
                    {t('workingInTeam')}
                </div>
                <div className='asiaexpo-venue-title'>
                    ASIAEXPO VENUE
                </div>
                <div className='static-home-box'>
                    <div className='static-home-block'>
                        <img src={PartnerOffers} className='static-home-box-image'/>
                        <p>{t("theBestOffers")}</p>
                    </div>
                    <div className='static-home-block'>
                        <img src={GlobalIcon} className='static-home-box-image'/>
                        <p>{t("globalSouth")}</p>
                    </div>
                    <div className='static-home-block'>
                        <img src={MarketEntry} className='static-home-box-image'/>
                        <p>{t("availableAllCountries")}</p>
                    </div>
                </div>
                <div className='title-for-suppliers first-section'>
                    <span className='text-congress-online companies home'>{t('ourSuppliers')}</span>
                    <div className='in-congress-online' onClick={() => navigate(`/congress-online`)}>
                        <span>{t("onlineCongress")}</span>
                        <ArrowIcon className='in-congress-online-image'/>
                    </div>
                </div>
                <SupplierCard/>

                <div className='title-for-suppliers'>
                    <div className='text-segment companies home segment'
                         onClick={() => navigate(`/catalog/animal-husbandry`)}>
                        {t("feedAdditivesAndVeterinary")} 
                        <ArrowIcon className='in-congress-online-image'/>
                    </div>
                    <div
                        className='products-amount'>{animalHusbandryProducts} {NormalizeCountForm(animalHusbandryProducts, wordsArray)}</div>
                </div>
                <div className='under-category-text'>{t('browseOffers')}</div>
                <div className='products-home-container'>
                </div>
                <div className='all-home-products'>
                    <ProductsContainer
                        categoryScreen={2}
                        loaderText="Загрузка продуктов..."
                        zeroText="Нет доступных продуктов."
                    />
                </div>
                <div className='title-for-suppliers '>
                    <div className='text-segment companies home segment'
                         onClick={() => navigate(`/catalog/plant-production`)}>
                        {t("agriculturalIndustry")} 
                        <ArrowIcon className='in-congress-online-image'/>
                    </div>
                    <div
                        className='products-amount'>{cropProductionProducts} {NormalizeCountForm(cropProductionProducts, wordsArray)}</div>
                </div>
                <div className='under-category-text'>{t('browseOffers')}</div>
                <div className='products-home-container'>
                </div>
                <div className='all-home-products'>
                    <ProductsContainer
                        categoryScreen={1}
                        loaderText="Загрузка продуктов..."
                        zeroText="Нет доступных продуктов."
                    />
                </div>

                {/*<div className='title-for-suppliers '>*/}
                {/*    <div className='text-segment companies home segment' onClick={() => navigate(`/technique`)}>*/}
                {/*        Техника*/}
                {/*        <ArrowIcon className='in-congress-online-image'/>*/}
                {/*    </div>*/}
                {/*    <div*/}
                {/*        className='products-amount'>{techniqueProducts} {NormalizeCountForm(techniqueProducts, wordsArray)}</div>*/}
                {/*</div>*/}
                {/*<div className='under-category-text'>{t('browseOffers')}</div>*/}
                {/*<div className='products-home-container'>*/}
                {/*</div>*/}
                {/*<div className='all-home-products'>*/}
                {/*    <ProductsContainer*/}
                {/*        products={products}*/}
                {/*        category={techniqueProductsId}*/}
                {/*        isLoading={loading}*/}
                {/*        loaderText={"Загружаем продукты ..."}*/}
                {/*        zeroText={"Продукты техники отсутствуют"}*/}
                {/*        maxItems={MAX_PRODUCTS_TO_DISPLAY}*/}
                {/*    />*/}
                {/*</div>*/}

                {/*<div className='title-for-suppliers '>*/}
                {/*    <div className='text-segment companies home segment'>*/}
                {/*        Лучшие предложения*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<BestOffers/>*/}

                {/*<div className='title-for-suppliers '>*/}
                {/*    <div className='text-segment companies home segment' onClick={() => navigate(`/services`)}>*/}
                {/*        Услуги*/}
                {/*        <ArrowIcon className='in-congress-online-image'/>*/}
                {/*    </div>*/}
                {/*    <div*/}
                {/*        className='products-amount'>{anotherProducts} {NormalizeCountForm(anotherProducts, wordsArray)}</div>*/}
                {/*</div>*/}
                {/*<div className='under-category-text'>{t('browseOffers')}</div>*/}
                {/*<div className='products-home-container'>*/}
                {/*</div>*/}
                {/*<div className='all-home-products'>*/}
                {/*    <ProductsContainer*/}
                {/*        products={products}*/}
                {/*        category={anotherProductsId}*/}
                {/*        isLoading={loading}*/}
                {/*        loaderText={"Загружаем продукты ..."}*/}
                {/*        zeroText={"Услуги отсутствуют"}*/}
                {/*        maxItems={MAX_PRODUCTS_TO_DISPLAY}*/}
                {/*    />*/}
                {/*</div>*/}

                <div className='title-for-suppliers '>
                    <div className='text-segment companies home segment'
                         onClick={() => navigate(`catalog/manufacturing-products`)}>
                        {t("foodAndBeverages")} 
                        <ArrowIcon className='in-congress-online-image'/>
                    </div>
                    <div
                        className='products-amount'>{manufacturingProducts} {NormalizeCountForm(manufacturingProducts, wordsArray)}</div>
                </div>
                <div className='under-category-text'>{t('browseOffers')}</div>
                <div className='products-home-container'>
                </div>
                <div className='all-home-products'>
                    <ProductsContainer
                        categoryScreen={4}
                        loaderText="Загрузка продуктов..."
                        zeroText="Нет доступных продуктов."
                    />
                </div>
                <div className='title-for-suppliers '>
                    <div className='text-segment companies home segment'
                         onClick={() => navigate(`/catalog/aquaculture-and-fisheries`)}>
                        {t("aquacultureAndFisheries")} 
                        <ArrowIcon className='in-congress-online-image'/>
                    </div>
                    <div
                        className='products-amount'>{aquacultureProducts} {NormalizeCountForm(aquacultureProducts, wordsArray)}</div>
                </div>
                <div className='under-category-text'>{t('browseOffers')}</div>
                <div className='products-home-container'>
                </div>
                <div className='all-home-products'>
                    <ProductsContainer
                        categoryScreen={3}
                        loaderText="Загрузка продуктов..."
                        zeroText="Нет доступных продуктов."
                    />
                </div>
            </BrowserView>

            <MobileView>
                {/*<div className='venue-gradient-box'>*/}
                {/*    <GradientBox/>*/}
                {/*</div>*/}

                <div className='venue-home-title'>
                    {t('workingInTeam')}
                </div>
                <div className='asiaexpo-venue-title'>
                    ASIAEXPO VENUE
                </div>
                <div className='static-home-box'>
                    <div className='static-home-block'>
                        <img src={PartnerOffers} className='static-home-box-image'/>
                        <p>{t("theBestOffers")}</p>
                    </div>
                    <div className='static-home-block'>
                        <img src={GlobalIcon} className='static-home-box-image'/>
                        <p>{t("globalSouth")}</p>
                    </div>
                    <div className='static-home-block'>
                        <img src={MarketEntry} className='static-home-box-image'/>
                        <p>{t("availableAllCountries")}</p>
                    </div>
                </div>
                <div className='title-for-suppliers first-section'>
                    <span className='text-congress-online companies home'>{t('ourSuppliers')}</span>

                </div>
                <SupplierCard/>

                <div className='title-for-suppliers'>
                    <div className='text-segment companies home segment'
                         onClick={() => navigate(`/catalog/animal-husbandry`)}>
                        {t("feedAdditivesAndVeterinary")} 
                        <ArrowIcon className='in-congress-online-image'/>
                    </div>
                    <div
                        className='products-amount'>{animalHusbandryProducts} {NormalizeCountForm(animalHusbandryProducts, wordsArray)}</div>
                </div>
                <div className='under-category-text'>{t('browseOffers')}</div>
                <div className='products-home-container'>
                </div>
                <div className='all-home-products'>
                    <ProductsContainer
                        categoryScreen={2}
                        loaderText="Загрузка продуктов..."
                        zeroText="Нет доступных продуктов."
                    />
                </div>
                <div className='title-for-suppliers '>
                    <div className='text-segment companies home segment'
                         onClick={() => navigate(`/catalog/plant-production`)}>
                        {t("agriculturalIndustry")} 
                        <ArrowIcon className='in-congress-online-image'/>
                    </div>
                    <div
                        className='products-amount'>{cropProductionProducts} {NormalizeCountForm(cropProductionProducts, wordsArray)}</div>
                </div>
                <div className='under-category-text'>{t('browseOffers')}</div>
                <div className='products-home-container'>
                </div>
                <div className='all-home-products'>
                    <ProductsContainer
                        categoryScreen={1}
                        loaderText="Загрузка продуктов..."
                        zeroText="Нет доступных продуктов."
                    />
                </div>
                {/*<div className='title-for-suppliers '>*/}
                {/*    <div className='text-segment companies home segment' onClick={() => navigate(`/technique`)}>*/}
                {/*        Техника*/}
                {/*        <ArrowIcon className='in-congress-online-image'/>*/}
                {/*    </div>*/}
                {/*    <div*/}
                {/*        className='products-amount'>{techniqueProducts} {NormalizeCountForm(techniqueProducts, wordsArray)}</div>*/}
                {/*</div>*/}
                {/*<div className='under-category-text'>{t('browseOffers')}</div>*/}
                {/*<div className='products-home-container'>*/}
                {/*</div>*/}
                {/*<div className='all-home-products'>*/}
                {/*    <ProductsContainer*/}
                {/*        products={products}*/}
                {/*        category={techniqueProductsId}*/}
                {/*        isLoading={loading}*/}
                {/*        loaderText={"Загружаем продукты ..."}*/}
                {/*        zeroText={"Продукты техники отсутствуют"}*/}
                {/*        maxItems={MAX_PRODUCTS_TO_DISPLAY}*/}
                {/*    />*/}
                {/*</div>*/}
                {/*<div className='title-for-suppliers '>*/}
                {/*    <div className='text-segment companies home segment'>*/}
                {/*        Лучшие предложения*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<BestOffers/>*/}

                {/*<div className='title-for-suppliers '>*/}
                {/*    <div className='text-segment companies home segment' onClick={() => navigate(`/services`)}>*/}
                {/*        Услуги*/}
                {/*        <ArrowIcon className='in-congress-online-image'/>*/}
                {/*    </div>*/}
                {/*    <div*/}
                {/*        className='products-amount'>{anotherProducts} {NormalizeCountForm(anotherProducts, wordsArray)}</div>*/}
                {/*</div>*/}
                {/*<div className='under-category-text'>{t('browseOffers')}</div>*/}
                {/*<div className='products-home-container'>*/}
                {/*</div>*/}
                {/*<div className='all-home-products'>*/}
                {/*    <ProductsContainer*/}
                {/*        products={products}*/}
                {/*        category={anotherProductsId}*/}
                {/*        isLoading={loading}*/}
                {/*        loaderText={"Загружаем продукты ..."}*/}
                {/*        zeroText={"Услуги отсутствуют"}*/}
                {/*        maxItems={MAX_PRODUCTS_TO_DISPLAY}*/}
                {/*    />*/}
                {/*</div>*/}
                <div className='title-for-suppliers '>
                    <div className='text-segment companies home segment'
                         onClick={() => navigate(`/catalog/manufacturing-products`)}>
                        {t("foodAndBeverages")} 
                        <ArrowIcon className='in-congress-online-image'/>
                    </div>
                    <div
                        className='products-amount'>{manufacturingProducts} {NormalizeCountForm(manufacturingProducts, wordsArray)}</div>
                </div>
                <div className='under-category-text'>{t('browseOffers')}</div>
                <div className='products-home-container'>
                </div>
                <div className='all-home-products'>
                    <ProductsContainer
                        categoryScreen={4}
                        loaderText="Загрузка продуктов..."
                        zeroText="Нет доступных продуктов."
                    />
                </div>
                <div className='title-for-suppliers '>
                    <div className='text-segment companies home segment'
                         onClick={() => navigate(`/catalog/aquaculture-and-fisheries`)}>
                        {t("aquacultureAndFisheries")} 
                        <ArrowIcon className='in-congress-online-image'/>
                    </div>
                    <div
                        className='products-amount'>{aquacultureProducts} {NormalizeCountForm(aquacultureProducts, wordsArray)}</div>
                </div>
                <div className='under-category-text'>{t('browseOffers')}</div>
                <div className='products-home-container'>
                </div>
                <div className='all-home-products'>
                    <ProductsContainer
                        categoryScreen={3}
                        loaderText="Загрузка продуктов..."
                        zeroText="Нет доступных продуктов."
                    />
                </div>
            </MobileView>
        </>
    );
}
